import React from 'react';
import { connect } from 'react-redux';
import * as qs from 'qs';

import Entities from '../common/Entities';
import OrdersTable from '../orders/OrdersTable';
import Edit from '../orders/Edit';
import Create from '../orders/Create';
import Pagination from 'react-js-pagination';
import { Grid, Row, Col } from 'react-bootstrap';
import { departments as depType, agents as agentType } from '../../constants/settingTypes';

import {
    fetchOrders as fetchOrdersAction,
    updateOrder as updateOrderAction,
    clearUpdateOrder as clearUpdateOrderAction,
    createOrder as createOrderAction,
    clearOrders as clearOrdersAction
} from '../../actions/orders';
import { taxiClasses } from '../../constants/taxiClasses'
import { clear as clearCreateAction } from "../../actions/customers";
import { states as orderStates, INIT as initState, ON_RECEIVING_POINT as onReceivingPointState, defaultHighlightColor } from '../../constants/orderStates'
import * as fetchingState from '../../constants/fetchingState';
import { getFormValues, change as changeFormValue, isValid } from 'redux-form';
import { parsePhoneNumber, formatPhone } from '../../extensions/phoneHelper';
import { withRouter } from 'react-router';
import * as permissions from '../../constants/permissions';

function queryToFilter(location, departments, agents, dcTypes) {
    departments = departments && departments.data != null ? departments.data : [];
    agents = agents && agents.data != null ? agents.data : [];
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    const dep = params.department ? departments.find(a => a.Id === +params.department) : undefined;
    const agent = params.agent ? agents.find(a => a.Id === +params.agent) : undefined;
    const departmentType = params.departmentType ? dcTypes.find(t => t.Id === +params.departmentType) : undefined;
    const filter = {
        states: orderStates.filter(os => params.states &&
            (typeof (params.states) === 'string' ?
                params.states === os.Id.toString()
                : params.states.includes(os.Id.toString()))),
        phone: params.phone,
        department: dep ? dep : params.department,
        agent: agent ? agent : params.agent,
        departmentType: departmentType ? departmentType : params.departmentType
    }
    return filter;
}

function filterToQuery({ phone, states, department, departmentType, agent }) {
    phone = phone ? parsePhoneNumber(phone) : undefined;
    states = states ? states.map(s => s.Id) : undefined;
    department = department ? (typeof (department) === 'string' ? department : department.Id) : null;
    departmentType = departmentType != null ? departmentType.Id : undefined;
    agent = agent ? (typeof (agent) === 'string' ? agent : agent.Id) : null;
    const query = qs.stringify({ phone, states, departmentType, department, agent }, { arrayFormat: 'repeat', skipNulls: true });
    return query;
}

const perPage = 15;
let OrdersTab = class extends React.Component {

    constructor(props) {
        super(props);

        this._loadOrders = this._loadOrders.bind(this);
        this._editModalSubmit = this._editModalSubmit.bind(this);
        this._clearCrudAction = this._clearCrudAction.bind(this);
        this._createModalSubmit = this._createModalSubmit.bind(this);
        this._pageChanged = this._pageChanged.bind(this);
    }

    _loadOrders() {
        const { isFilterValid, filter, history, location: { pathname } } = this.props;
        if (!isFilterValid)
            return;

        const query = filter ? filterToQuery(filter) : '';
        history.push(`${pathname}?${query}`);
    }

    componentDidMount() {
        const { location: { search, pathname }, isFilterValid, fetchOrdersAction } = this.props;
        const { phone } = qs.parse(search, { ignoreQueryPrefix: true });
        const path = pathname.replace("/orders", '');
        if (isFilterValid && phone) {
            fetchOrdersAction(path, { phone, page: 1 });
        }
    }

    componentWillUnmount() {
        this.props.clearOrdersAction();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location !== this.props.location) {
            var { page } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
            const { states, phone, agent, departmentType, department } = queryToFilter(this.props.location, this.props.departments, this.props.agents, this.props.dcTypes);
            this.props.changeFormValue(this.props.filterName, 'states', states);
            this.props.changeFormValue(this.props.filterName, 'phone', formatPhone(phone));
            this.props.changeFormValue(this.props.filterName, 'department', department ? department : "");
            this.props.changeFormValue(this.props.filterName, 'agent', agent ? agent : "");
            this.props.changeFormValue(this.props.filterName, 'departmentType', departmentType ? departmentType : "");
            const path = this.props.location.pathname.replace("/orders", '');

            this.props.fetchOrdersAction(path, {
                states: states.map(s => s.Id),
                phone,
                page: page !== undefined ? page : 1,
                agent: agent ? agent.Id : agent,
                departmentType,
                department: department ? department.Id : department
            });
        }
    }

    _editModalSubmit(editedOrderEntity) {
        this.props.updateOrderAction({
            Id: editedOrderEntity.Id,
            State: editedOrderEntity.State,
            OffloadDate: editedOrderEntity.OffloadDate,
            PickupDate: editedOrderEntity.PickupDate,
            PickupAddress: editedOrderEntity.PickupAddress,
            Items: editedOrderEntity.Items,
            PickupTaxiClass: editedOrderEntity.PickupTaxiClass,
            OffloadTaxiClass: editedOrderEntity.OffloadTaxiClass,
            DryCleaningDepartmentId: editedOrderEntity.DryCleaningDepartmentId,
            Discount: editedOrderEntity.Discount,
            IsPickupNow: editedOrderEntity.IsPickupNow,
            Comment: editedOrderEntity.Comment,
            UseAlternativePayment: editedOrderEntity.UseAlternativePayment,
            HighlightColor: editedOrderEntity.HighlightColor
        });
    }
    _createModalSubmit(createOrderEntity) {
        this.props.createOrderAction(createOrderEntity);
    }

    _clearCrudAction(isNew) {
        this.props.clearUpdateOrderAction();
        this.props.clearCreateAction();
    }

    _pageChanged(activePage) {
        const { pathname, search } = this.props.location;
        const params = qs.parse(search, { ignoreQueryPrefix: true });
        params.page = activePage;
        const url = `${pathname}?${qs.stringify(params, { arrayFormat: 'repeat' })}`;
        this.props.history.push(url);
    }

    render() {
        const { orders, fetching, updateFetching, updateResult, isReceptionPoint, totalItemsCount, location: { search }, filterComponent: Filter } = this.props;
        const activePage = qs.parse(search, { ignoreQueryPrefix: true }).page ? +qs.parse(search, { ignoreQueryPrefix: true }).page : 1;
        const createEntity = {
            CreatedAt: null,
            Id: 0,
            Items: [],
            OffloadDate: null,
            OffloadTaxiClass: taxiClasses[0],
            Phone: "",
            PickupAddress:
            {
                Address: "",
                City: "",
                District: "",
                Entrance: "",
                Flat: "",
                Floor: "",
                GeoAddress: { X: 0, Y: 0 },
                Id: 0,
                IntercomCode: "",
                IsDeleted: false
                ,
                PickupAddressString: "",
                PickupDate: null,
                State: 0
            },
            PickupTaxiClass: taxiClasses[0],
            State: isReceptionPoint ? orderStates.find(os => os.Id == onReceivingPointState) : orderStates.find(os => os.Id == initState),
            HighlightColor: defaultHighlightColor
        }

        const filterData = queryToFilter(this.props.location, this.props.departments, this.props.agents, this.props.dcTypes);
        return (
            <div>
                {Filter && <Filter initialValues={filterData} />}
                <Entities
                    entities={orders}
                    fetching={fetching}
                    updateFetching={updateFetching}
                    createFetching={updateFetching}
                    updateResult={updateResult}
                    canCreate={false}
                    contentTable={OrdersTable}
                    editModal={Edit}
                    createModal={Create}
                    loadAction={this._loadOrders}
                    updateAction={this._editModalSubmit}
                    createAction={this._createModalSubmit}
                    clearCrudAction={this._clearCrudAction}
                    header='Заказы'
                    createEntity={createEntity} />
                <Grid>
                    <Row>
                        <Col lg={12} style={{ textAlign: 'center' }}>
                            {fetching === fetchingState.FETCHED && totalItemsCount > perPage && <Pagination
                                totalItemsCount={totalItemsCount}
                                onChange={this._pageChanged}
                                activePage={activePage}
                                itemsCountPerPage={perPage}
                                pageRangeDisplayed={15} />}
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

function mapToProps(state, { filterName }) {
    const orders = state.application.get('orders');
    const fetching = orders.get('fetching');
    const updateFetching = orders.get('updateFetching');
    const updateResult = orders.get('updateResult');
    const filter = getFormValues(filterName)(state);
    const isFilterValid = isValid(filterName)(state);
    const agents = state.application.get('settings')[agentType];
    const departments = state.application.get('settings')[depType];
    const isReceptionPoint = permissions.getRole() == permissions.RECEPTION_POINT;
    return {
        orders: orders.get('orders').sort((prev, next) => next.Id - prev.Id),
        fetching,
        updateFetching,
        updateResult,
        totalItemsCount: orders.get('pages') * perPage,
        filter,
        isFilterValid,
        agents,
        departments,
        isReceptionPoint
    };
}

OrdersTab = withRouter(connect(mapToProps, {
    fetchOrdersAction,
    updateOrderAction,
    clearUpdateOrderAction,
    clearCreateAction,
    createOrderAction,
    clearOrdersAction,
    changeFormValue
})(OrdersTab));

export default OrdersTab;


// WEBPACK FOOTER //
// ./src/components/orders/OrdersTab.jsx